// @mui
import { styled, alpha } from "@mui/material/styles";
// config
import { BOTTOM_NAVIGATION, HEADER, NAVBAR } from "../../../../config";
import { paths } from "routes/paths";
// router
// components
import ErrorBoundary from "components/common/ErrorBoundary/ErrorBoundary";
import { Outlet, useLocation } from "react-router-dom";
// hooks
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { useCollapseDrawer } from "hooks/index";

interface StyledOutletProps {
  collapseClick: boolean;
  withNavbar: boolean;
  screenHeight: number;
}

const StyledOutlet = styled("main", {
  shouldForwardProp: (prop) =>
    prop !== "collapseClick" &&
    prop !== "withNavbar" &&
    prop !== "screenHeight",
})<StyledOutletProps>(({ withNavbar, theme, screenHeight }) => ({
  flexGrow: 1,
  padding: theme.spacing(0, 2),
  paddingBottom: theme.spacing(2),
  marginTop: 4,
  marginBottom: 90,
  backgroundColor: theme.palette.background.default,
  boxSizing: "border-box",
  [theme.breakpoints.up('md')]: {
    marginBottom: 16,
  },
}));

const StyledContentWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  minHeight: "calc(100vh - 160px)",
  height: "auto",
  padding: theme.spacing(3, 2),
  backgroundColor: theme.palette.background.paper,
  overflow: "auto",
  borderRadius: 20,
  border:
    theme.palette.mode === "dark"
      ? `1px solid rgba(255, 255, 255, 0.04)`
      : "none",
  boxShadow: "none",
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4, 3),
  },
}));

export const DashboardOutlet = () => {
  const { height } = useWindowDimensions();
  const { pathname } = useLocation();
  const { collapseClick } = useCollapseDrawer();
  const hasHorizontalNavbar = [paths.root, paths.calendar.calendar].includes(
    pathname
  );

  return (
    <StyledOutlet
      screenHeight={height}
      collapseClick={collapseClick}
      withNavbar={hasHorizontalNavbar}
    >
      <ErrorBoundary>
        <StyledContentWrapper>
          <Outlet />
        </StyledContentWrapper>
      </ErrorBoundary>
    </StyledOutlet>
  );
};
